import { apiSlice } from "../../app/api/apiSlice";
import { COMPANY_ADMIN } from "../../utils/common-constants";

// The user-detail endpoint returns its user object in `data`. Keep all other
// access levels untouched, but Company Admins must always be marked as having
// set the configuration at the organization level.
export const applyCompanyAdminSetByAdmin = (response) => {
	const userDetails = response?.data;

	if (userDetails?.access_level !== COMPANY_ADMIN) return response;

	return {
		...response,
		data: {
			...userDetails,
			set_by_admin: true,
		},
	};
};

export const userDetailsApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		userDetails: builder.mutation({
			query: (credentials) => ({
				url: "/api/v1/user/user_detail/",
				method: "GET",
				body: credentials,
			}),
			transformResponse: applyCompanyAdminSetByAdmin,
		}),
	}),
});

export const { useUserDetailsMutation } = userDetailsApiSlice;
